import { render, staticRenderFns } from "./acoes-campo.vue?vue&type=template&id=32e9226a&scoped=true&"
import script from "./acoes-campo.vue?vue&type=script&lang=js&"
export * from "./acoes-campo.vue?vue&type=script&lang=js&"
import style0 from "./acoes-campo.vue?vue&type=style&index=0&id=32e9226a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e9226a",
  null
  
)

export default component.exports